import component from './component-fr.json'
import errorMessage from './errorMessage-fr.json'
import general from './general-fr.json'
import biomarkConfigurationModal from './modals/biomarkConfigurationModal-fr.json'
import compensationMatrixAnalysisConfigurationModal from './modals/compensationMatrixAnalysisConfigurationModal-fr.json'
import createDataSourceModal from './modals/createDataSourceModal-fr.json'
import createDataStoreModal from './modals/createDataStoreModal-fr.json'
import createOfrDocumentTemplateModal from './modals/createOfrDocumentTemplateModal-fr.json'
import createSearchReviewModal from './modals/createSearchReviewModal-fr.json'
import createWorkspaceModal from './modals/createWorkspaceModal-fr.json'
import delConfigurationModal from './modals/delConfigurationModal-fr.json'
import processDeviationModal from './modals/processDeviationModal-fr.json'
import regulatorySubmissionConfigurationModal from './modals/regulatorySubmissionConfigurationModal-fr.json'
import reviewAnalysisConfigurationModal from './modals/reviewAnalysisConfigurationModal-fr.json'
import auditTrailListPage from './pages/auditTrailListPage-fr.json'
import dataSourceDetailsPage from './pages/dataSourceDetailsPage-fr.json'
import dataSourcesListPage from './pages/dataSourcesListPage-fr.json'
import dataStoreDetailPage from './pages/dataStoreDetailsPage-fr.json'
import dataStoresListPage from './pages/dataStoresListPage-fr.json'
import forgotPasswordPage from './pages/forgotPasswordPage-fr.json'
import inviteCompleteProfile from './pages/inviteCompleteProfile-fr.json'
import loginPage from './pages/loginPage-fr.json'
import ofrDocumentTemplateDetailsPage from './pages/ofrDocumentTemplateDetailsPage-fr.json'
import ofrDocumentTemplateListPage from './pages/ofrDocumentTemplateListPage-fr.json'
import searchDocumentSummariesPage from './pages/searchDocumentSummariesPage-fr.json'
import searchPage from './pages/searchPage-fr.json'
import searchReviewDetailsPage from './pages/searchReviewDetailsPage-fr.json'
import searchReviewListPage from './pages/searchReviewListPage-fr.json'
import searchReviewSearchDetailsPage from './pages/searchReviewSearchDetailsPage-fr.json'
import searchReviewSearchDocumentDetailsPage from './pages/searchReviewSearchDocumentDetailsPage-fr.json'
import settingsPage from './pages/settingsPage-fr.json'
import smartFunctionDetailsPage from './pages/smartFunctionDetailsPage-fr.json'
import userDetailsPage from './pages/userDetailsPage-fr.json'
import userListPage from './pages/userListPage-fr.json'
import workspaceDetailsPage from './pages/workspaceDetailsPage-fr.json'
import workspaceListPage from './pages/workspaceListPage-fr.json'

const translationsFR = {
  ...component,
  ...general,
  auditTrailListPage,
  biomarkConfigurationModal,
  compensationMatrixAnalysisConfigurationModal,
  reviewAnalysisConfigurationModal,
  createDataSourceModal,
  createDataStoreModal,
  createOfrDocumentTemplateModal,
  createSearchReviewModal,
  createWorkspaceModal,
  dataSourceDetailsPage,
  dataSourcesListPage,
  dataStoreDetailPage,
  dataStoresListPage,
  delConfigurationModal,
  errorMessage,
  forgotPasswordPage,
  inviteCompleteProfile,
  loginPage,
  ofrDocumentTemplateDetailsPage,
  ofrDocumentTemplateListPage,
  regulatorySubmissionConfigurationModal,
  searchDocumentSummariesPage,
  searchPage,
  searchReviewDetailsPage,
  searchReviewListPage,
  searchReviewSearchDetailsPage,
  searchReviewSearchDocumentDetailsPage,
  settingsPage,
  smartFunctionDetailsPage,
  userDetailsPage,
  userListPage,
  workspaceDetailsPage,
  workspaceListPage,
  processDeviationModal,
}

export default translationsFR
